import { render, staticRenderFns } from "./LiveBattles.vue?vue&type=template&id=cbf6bb8e&scoped=true&"
import script from "./LiveBattles.vue?vue&type=script&lang=ts&"
export * from "./LiveBattles.vue?vue&type=script&lang=ts&"
import style0 from "./LiveBattles.vue?vue&type=style&index=0&id=cbf6bb8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf6bb8e",
  null
  
)

export default component.exports